import {
  ACCESS_TOKEN_NAME,
  JSON_CONTENT_TYPE,
} from '../../_constant/constants';
import { IApiParams } from '../../_interface/IApiParams';
import { getApi } from '../getApi';

export const apiGetAccountant = async (id?: number) => {
  const params: IApiParams = {
    url:
      id === undefined
        ? `/accountant/getAccountant.php`
        : `/accountant/getAccountant.php?id=${id}`,
    headers: {
      'Content-Type': JSON_CONTENT_TYPE,
      'Access-Token': localStorage.getItem(ACCESS_TOKEN_NAME),
    },
  };
  return getApi(params, 'GET');
};
